import { Modal, Form, Input, Select, DatePicker } from "antd";
import dayjs from "dayjs";

const { Item } = Form;
const { TextArea } = Input;

const CreateEditJobModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  onSubmit = () => {},
  initialValues = null
}) => {
  const [form] = Form.useForm();
  const isEdit = Boolean(initialValues);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  /**
   * Validate + submit job form
   */
  const handleOk = () => {
    form
      .validateFields()
      .then((jobFormValues) => {
        onSubmit(jobFormValues);
      })
      .catch(() => {});
  };

  let formInitialValues = initialValues ? { ...initialValues } : {};
  if (formInitialValues?.activeFrom) {
    formInitialValues.activeFrom = dayjs(formInitialValues.activeFrom);
  }
  if (formInitialValues?.activeTill) {
    formInitialValues.activeTill = dayjs(formInitialValues.activeTill);
  }

  return (
    <Modal
      title={isEdit ? "Edit Job" : "Create Job"}
      open={isModalOpen}
      onCancel={handleCancel}
      onOk={handleOk}
      okText="Save"
      destroyOnClose
    >
      <Form layout="vertical" form={form} initialValues={isEdit ? formInitialValues : {}}>
        <Item
          name="title"
          label="Job Title"
          rules={[{ required: true, message: "Job title is required" }]}
        >
          <Input placeholder="Software Engineer" />
        </Item>

        <Item
          name="description"
          label="Description"
          rules={[{ required: true, message: "Description is required" }]}
        >
          <TextArea
            rows={8}
            placeholder={"Role description...\n\nStart a line with '- ' for a bullet.\nLeave a blank line between paragraphs."}
          />
        </Item>

        <Item
          name="location"
          label="Location"
          rules={[{ required: true, message: "Location is required" }]}
        >
          <Input placeholder="Remote / Hybrid" />
        </Item>

        <Item
          name="employmentType"
          label="Employment Type"
          rules={[{ required: true, message: "Employment type is required" }]}
        >
          <Select
            placeholder="Select employment type"
            options={[
              { label: "Full Time", value: "Full Time" },
              { label: "Part Time", value: "Part Time" },
              { label: "Intern", value: "Intern" }
            ]}
          />
        </Item>

        <Item name="salaryRangeDescription" label="Salary Range" rules={[{ max: 200, message: "Keep it under 200 characters" }]}>
          <Input placeholder="₹20,000 to 25,000 per month + incentive" />
        </Item>

        <Item
          name="applyRedirectUrl"
          label="Apply URL"
          rules={[{ required: true, message: "Apply URL is required" }]}
        >
          <Input placeholder="https://forms.gle/..." />
        </Item>

        <Item
          name="activeFrom"
          label="Active From"
          rules={[{ required: true, message: "Active from date is required" }]}
        >
          <DatePicker
            showTime
            format="YYYY-MM-DD HH:mm"
            style={{ width: "100%" }}
            placeholder="Select start date"
          />
        </Item>

        <Item name="activeTill" label="Active Till">
          <DatePicker
            showTime
            format="YYYY-MM-DD HH:mm"
            style={{ width: "100%" }}
            placeholder="Select end date"
          />
        </Item>
      </Form>
    </Modal>
  );
};

export default CreateEditJobModal;
